import { Box, Button, Stack } from "@mui/joy";
import { theme } from "styles/theme";
import React, { useState } from "react";
import CustomTypography from "../../../../components/common/CustomTypography";
import { useOnboardingPromotionPage } from "../../../../hooks/useOnboardingPromotionPage";

interface SelectOption {
  id: number;
  label: string;
  score: number;
}

export const selectOptionList: SelectOption[] = [
  { id: 1, label: "하루에도 여러번", score: 28 },
  { id: 2, label: "하루에 한 번 정도", score: 24 },
  { id: 3, label: "2-3일에 한 번 정도", score: 20 },
  { id: 4, label: "일주일에 한 번 정도", score: 16 },
  { id: 5, label: "더 빈도가 적음", score: 12 },
];

export default function Goal_6_Promotion() {
  const [isAnimating, setIsAnimating] = useState(false); // 애니메이션 상태 추가

  const pageKey = "goal_6"; // 페이지를 구분할 키 값

  const { singleSelectionId, updateSingleSelection, handleNext } =
    useOnboardingPromotionPage({
      pageKey,
      nextPageRoute: "/promotion-onboarding/goal/7", // 다음 페이지 경로 지정
    });

  // 버튼 선택 로직
  const handleOptionChange = (optionId: number) => {
    updateSingleSelection(optionId);

    setTimeout(() => {
      setIsAnimating(false);
      handleNext({ singleSelectionId: optionId });
    }, 300);
  };

  return (
    <Stack spacing={5} sx={{ height: "100%" }}>
      <CustomTypography
        variant="Subtitle"
        fontWeight={500}
        sx={{
          color: theme.vars.palette.Content.Strong,
        }}
      >
        앞선 문제들은 어떤 빈도로 찾아오곤 하나요?
      </CustomTypography>
      <Box sx={{ flex: 1, overflowY: "auto" }}>
        <Stack
          direction={"column"}
          sx={{
            width: "100%",
            whiteSpace: "nowrap",
            flexWrap: "wrap",
            gap: 1,
          }}
        >
          {selectOptionList.map(({ id, label }, optionIndex) => (
            <Stack key={`select_option_${id}`} sx={{ flexGrow: 1, gap: 1 }}>
              <Button
                fullWidth
                variant={"SingleSlim"}
                size={"lg"}
                color={singleSelectionId === id ? "primary" : "secondary"}
                sx={{
                  transition: "background-color 0.3s ease", // ease 애니메이션 추가
                }}
                onClick={() => {
                  handleOptionChange(id);
                }}
              >
                {label}
              </Button>
            </Stack>
          ))}
        </Stack>
      </Box>
    </Stack>
  );
}
